// reducers
function footer(state = {}, action) {
  switch (action.type) {
    case 'FOOTER_DATA_SUCCESS':
      return action.footer;

    default:
      return state;
  }
}

export default footer;
